module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_input"
  }, [_c('ddHeader', {
    attrs: {
      "title": _vm.$route.params.item.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input_contain"
  }, [(_vm.$route.params.item.type !== 'gender') ? _c('div', {
    staticClass: "submit_contain"
  }, [(_vm.$route.params.item.type !== 'desc') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inValue),
      expression: "inValue"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.defaultTxt
    },
    domProps: {
      "value": (_vm.inValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isClear && _vm.$route.params.item.type !== 'desc') ? _c('div', {
    staticClass: "x_icon",
    on: {
      "click": _vm.clear
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.params.item.type == 'desc') ? _c('div', {
    staticClass: "submit_contain submit_contain_desc"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inValue),
      expression: "inValue"
    }],
    attrs: {
      "placeholder": _vm.defaultTxt
    },
    domProps: {
      "value": (_vm.inValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inValue = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.params.item.type == 'gender') ? _c('div', {
    staticClass: "sex"
  }, [_c('div', {
    staticClass: "sex_item",
    on: {
      "click": function($event) {
        _vm.sex = 0
      }
    }
  }, [_c('div', {
    staticClass: "duihao_gray",
    class: {
      duihao_red: this.sex == 0
    }
  }), _vm._v(" "), _c('span', [_vm._v("男")])]), _vm._v(" "), _c('div', {
    staticClass: "sex_item",
    on: {
      "click": function($event) {
        _vm.sex = 1
      }
    }
  }, [_c('div', {
    staticClass: "duihao_gray",
    class: {
      duihao_red: this.sex == 1
    }
  }), _vm._v(" "), _c('span', [_vm._v("女")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "save",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), (_vm.errobj.type) ? _c('popup', {
    attrs: {
      "pop-obj": _vm.errobj
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-127da4e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editInput.vue
// module id = 213
// module chunks = 3